import { AppComponent } from './app.component';

// Angular
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { AppRoutingModule } from './app-routing.module';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA, inject, provideAppInitializer } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { OAuthModule } from 'angular-oauth2-oidc';
import { AuthGuard, CONFIGURATION } from '@acpgruppe/essp-ui';
import { AuthConfigService } from '@acpgruppe/essp-ui';
import { environment } from '../environments/environment';
import { PermissionGuard } from '@acpgruppe/essp-ui';
import { ToastrModule } from 'ngx-toastr';

import { providePrimeNG } from 'primeng/config';
import { AppTrackerService } from '@acpgruppe/essp-ui';
import { EsspThemeConfiguration } from '@acpgruppe/essp-ui';

import { appConfig } from 'src/environments/app-config';
import { TokenInterceptorService } from './token-interceptor-service';

@NgModule({ declarations: [AppComponent],
    bootstrap: [AppComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA], imports: [OAuthModule.forRoot(),
        ToastrModule.forRoot(),
        BrowserModule,
        BrowserAnimationsModule,
        AppRoutingModule,
        FormsModule], providers: [
        AuthGuard,
        AuthConfigService,
        PermissionGuard,
        provideAppInitializer(() => {
        const initializerFn = ((initialAuthService: AuthConfigService) => () => initialAuthService.initAuth(environment))(inject(AuthConfigService));
        return initializerFn();
      }),
        provideAppInitializer(() => {
        const initializerFn = (() => {
                const tracker = inject(AppTrackerService);
                return () => {
                    return Promise.resolve();
                };
            })();
        return initializerFn();
      }),
        {
            provide: HTTP_INTERCEPTORS,
            useClass: TokenInterceptorService,
            multi: true,
        },
        { provide: CONFIGURATION, useValue: appConfig },
        provideHttpClient(withInterceptorsFromDi()),
    providePrimeNG({
      theme: EsspThemeConfiguration,
    }),
    ] })
export class AppModule {}
